import React from "react";
import { KanbanSquare, LayoutList, Users, BarChart3, ListTodo, Inbox } from "lucide-react";

const ADMIN_TABS = [
    { id: "board", label: "Board", shortLabel: "Board", icon: KanbanSquare },
    { id: "list", label: "Task list", shortLabel: "List", icon: LayoutList },
    { id: "inbox", label: "Inbox", shortLabel: "Inbox", icon: Inbox },
    { id: "assignments", label: "By assignee", shortLabel: "Team", icon: Users },
    { id: "analytics", label: "Analytics", shortLabel: "Stats", icon: BarChart3 },
];

const STAFF_TABS = [
    { id: "now", label: "Now", shortLabel: "Now", icon: ListTodo },
    { id: "board", label: "Board", shortLabel: "Board", icon: KanbanSquare },
    { id: "list", label: "Task list", shortLabel: "List", icon: LayoutList },
];

const TaskViewTabs = ({ active, onChange, role = "admin", compact = false }) => {
    const tabs = role === "staff" ? STAFF_TABS : ADMIN_TABS;
    return (
        <div
            className={`task-view-tabs ${compact ? "task-view-tabs--header" : ""}`}
            role="tablist"
            aria-label="Task views"
        >
            {tabs.map(({ id, label, shortLabel, icon: Icon }) => (
                <button
                    key={id}
                    type="button"
                    role="tab"
                    aria-selected={active === id}
                    onClick={() => onChange(id)}
                    className={`task-view-tabs__btn ${active === id ? "is-active" : ""}`}
                >
                    <Icon size={14} className="shrink-0" />
                    <span className="task-view-tabs__short">{shortLabel}</span>
                    <span className="task-view-tabs__full">{label}</span>
                </button>
            ))}
        </div>
    );
};

export default TaskViewTabs;
